import type { HttpError } from '@packages/domain/constants/http';
import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import { otp } from 'services/payex/otp/otp';
import type { SendOtpParams, SendOtpResponse } from 'services/payex/otp/types';

const useSendOtp = (): UseMutationResult<
  SendOtpResponse,
  HttpError,
  SendOtpParams
> =>
  useMutation<SendOtpResponse, HttpError, SendOtpParams>({
    mutationKey: ['otp', 'send'],
    mutationFn: params => otp.send(params),
  });

export { useSendOtp };
